module.exports = __webpack_public_path__ + "asset/img/bottomEWM.84dc6ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottomEWM.png
// module id = bpxq
// module chunks = 1